import React, { useState, useEffect, useRef } from 'react';
// import Helmet from 'react-helmet';
import AppHead from './AppHead';
import Login from './Login';
import useHash from './useHash';
import { Link, usePage } from '@inertiajs/inertia-react';
import { BiChevronDown, BiMenu, BiSearch, BiUser, BiInfoCircle } from 'react-icons/bi';
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube  } from 'react-icons/fa';
import { Inertia } from '@inertiajs/inertia';

// check for localstorage
const localStorageAvailable = () => {
    if (typeof(Storage) !== "undefined") {
        return true;
    }
    else {
        return false;
    }
}

export default function Layout({ title, children, isHome }) {
    const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [openSearchModal, setOpenSearchModal] = useState(false);
    const [openLoginModal, setOpenLoginModal] = useState(false);
    const inputRef = useRef(null);
    const { isLoggedIn, authUser } = usePage().props;
    const [hash, setHash] = useHash();
    const [isShrunk, setShrunk] = useState(false);
    const d = new Date();
    const year = d.getFullYear();

    // adapted from https://phuctm97.com/blog/auto-shrink-header-on-scroll
    const handler = () => {
        setShrunk((isShrunk) => {
            if (!isShrunk && document.querySelector('.drawer-content').scrollTop > 20) {
                return true;
            }

            if (isShrunk && document.querySelector('.drawer-content').scrollTop < 4) {
                return false;
            }

            return isShrunk;
        });
    };

    useEffect(() => {
        if(isHome){
            document.querySelector('.drawer-content').addEventListener("scroll", handler);
            return () => document.querySelector('.drawer-content').removeEventListener("scroll", handler);
        }
    }, []);
    
    const handleSubmit = (e) => {
        e.preventDefault();
        //setOpenSearchModal(false);
        Inertia.get(`/on-demand/search/`, { query: searchQuery, onFinish: setOpenSearchModal(false) });
    }

    const handleQuery = (query) => {
        //setOpenSearchModal(false);
        Inertia.get(`/on-demand/search/`, { query: query, onFinish: setOpenSearchModal(false) });
    }

    const loginHasErrors = (hasError) => {
        if (hasError) {
            setOpenLoginModal(true);
        } else {
            closeLoginModal();
        }
    }

    // focus on search on load
    useEffect(() =>{
        if(inputRef && openSearchModal){
            inputRef.current.focus();
        }
    }, [openSearchModal]);

    // detect hash to open login modal
    useEffect(() =>{
        if(hash==='#login'){
            setIsHamburgerOpen(false);
            setOpenLoginModal(true);
            setHash("#login");
        }
    }, [hash]);

    const closeLoginModal = () => {
        setOpenLoginModal(false);
        setHash("");
    }

    return (
        <>
        <AppHead title={title} />

        <div className="drawer drawer-end">
            <input id="hamburger-menu" type="checkbox" className="drawer-toggle" checked={isHamburgerOpen} />
            <div className="drawer-content overflow-x-clip">
                <div className="bg-[#19181C] border-b border-solid border-[#4F4F4F] fixed z-[1000] w-full">
                    <div className="container-fluid lg:container">
                        <div className="navbar h-24 md:h-20 items-end md:items-center row w-auto p-0 bg-transparent border-none">
                            <div className="col-6 h-14 md:h-20 md:col-2 lg:col-3">
                                <a href="/" className="pl-0 pr-2 md:pl-2 md:pr-2 xl:pl-4 xl:pr-4 text-base md:text-sm lg:text-base">
                                    <img src="/assets/images/jpm-plus-logo.svg" className="h-5 md:h-5 lg:h-9" alt="Joseph Prince Ministries" />
                                </a>
                            </div>
                            <div className="col-6 h-14 flex justify-end md:hidden">
                                {/* <button className="btn modal-button btn-ghost" onClick={() => setOpenSearchModal(true)}><BiSearch size="24px" /></button> */}

                                <label htmlFor="hamburger-menu" tabIndex="0" className="btn btn-ghost lg:hidden !pl-2 !pr-2" onClick={() => setIsHamburgerOpen(true)}> 
                                    <BiMenu size="24px" />
                                </label>
                            </div>
                            <div className="col-12 md:col-10 lg:col-9 justify-end p-0">
                                <ul className="pl-0 pr-0 justify-evenly md:p-0 md:justify-evenly lg:justify-end h-14 md:h-10 items-center menu menu-horizontal w-full bg-[#242424] md:bg-transparent md:border-t-0 border-t border-b border-solid border-[#4F4F4F] md:border-none">
                                    <li tabIndex="0">
                                        <Link href="/on-demand" className="rounded gap-0 pl-2 pr-2 md:pl-2 md:pr-2 xl:pl-4 xl:pr-4 text-sm md:text-sm lg:text-base">
                                            On Demand
                                        </Link>
                                    </li>
                                    <li tabIndex="0">
                                        <a className="rounded gap-0 pl-2 pr-2 md:pl-2 md:pr-2 xl:pl-4 xl:pr-4 text-sm md:text-sm lg:text-base">
                                            Channels <BiChevronDown size="24px" />
                                        </a>
                                        <ul className="p-2 bg-neutral z-50 text-sm md:text-sm lg:text-base channelsMenu">
                                            <li><Link href="/on-demand/latest">Joseph Prince Ministries</Link></li>
                                            <li><Link href="/on-demand/channel/grc-online">Church Online - Grace Revolution Church</Link></li>
                                            <li><Link href="/on-demand/channel/grace-revolution-worship">Worship Music - Grace Revolution Worship</Link></li>
                                            <li><Link href="/on-demand/channel/decibel">Youth & Young Adults - Decibel</Link></li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="/donate" className="rounded pl-2 pr-2 md:pl-2 md:pr-2 xl:pl-4 xl:pr-4 text-sm md:text-sm lg:text-base">
                                            Donate
                                        </a>
                                    </li>
                                    <li tabIndex="0" className="hidden md:flex">
                                        <a className="gap-0 md:pl-2 md:pr-2 xl:pl-4 xl:pr-4 text-base md:text-sm lg:text-base">
                                            More <BiChevronDown size="24px" />
                                        </a>
                                        <ul className="p-2 bg-neutral z-50">
                                            <li><a href="/monthly-offer">Monthly Offer</a></li>
                                            <li><a href="/prayer/prayer-request">Prayer</a></li>
                                            <li><a href="/blog/praise-reports">Praise Reports</a></li>
                                            <li><a href="/donate">Be a Grace Legacy Builder</a></li>
                                            <li><a href="/">Back to JosephPrince.org</a></li>
                                        </ul>
                                    </li>
                                    {isLoggedIn ?
                                        <li tabIndex="0" className="hidden md:flex dropdown-end">
                                            <a className="gap-0 md:pl-2 md:pr-2 xl:pl-4 xl:pr-4 text-base md:text-sm lg:text-base">
                                                <BiUser size="24px" /> <BiChevronDown size="24px" />
                                            </a>
                                            <ul className="p-2 bg-neutral z-50">
                                                <li><a href="/account">My Account</a></li>
                                                <li><a href="/account/library">Library</a></li>
                                                <li><a href="/logout">Log Out</a></li>
                                            </ul>
                                        </li>
                                    : 
                                        <>
                                            <li className="hidden md:flex">
                                                <a href="#login" className="rounded md:pl-2 md:pr-2 xl:pl-4 xl:pr-4 text-base md:text-sm lg:text-base">Log In</a>
                                            </li>
                                            <li className="hidden md:flex">
                                                <a href="/register?source=plus&new=true" className="btn btn-primary rounded hidden md:flex md:ml-2 md:mr-2 xl:ml-4 xl:mr-4">Sign Up</a>
                                            </li>
                                        </>
                                    }
                                    {/* <li className="hidden md:flex">
                                        <button className="btn modal-button btn-ghost" onClick={() => setOpenSearchModal(true)}><BiSearch size="24px" /></button>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`pt-[112px] md:pt-[80px]`}>
                    {children}
                </div>

                {/* Footer */}
                <footer className="footer footer-center p-10 pb-[80px] bg-[#19181C] text-base-content rounded">
                    {/* <div className="grid grid-flow-col gap-4">
                        <Link href="/on-demand" className="link link-hover">JPM+ Home</Link> 
                        <Link href="/monthly-offer" className="link link-hover">Monthly Offer</Link> 
                        <Link href="/doante" className="link link-hover">Donate</Link> 
                        <Link href="/" className="link link-hover">Back to JosephPrince.org</Link>
                    </div>  */}
                    <div>
                        <div className="grid grid-flow-col gap-5">
                            <a href="http://www.facebook.com/josephprince" target="_blank"><FaFacebook size="32px" /></a>
                            <a href="http://www.twitter.com/josephprince" target="_blank"><FaTwitter size="32px" /></a>
                            <a href="http://www.instagram.com/josephprince" target="_blank"><FaInstagram size="32px" /></a>
                            <a href="https://www.youtube.com/c/josephprinceministriesusa" target="_blank"><FaYoutube size="32px" /></a>
                        </div>
                    </div> 
                    <div>
                        <p>&copy; Joseph Prince Ministries {year}. <br/> PO Box 2115, Fort Mill, SC 29716, USA</p>
                    </div>
                </footer>

                {/* Search Modal */}
                <div className={`modal z-[100000] ` + (openSearchModal ? 'modal-open' : '')} onClick={() => setOpenSearchModal(false)}>
                    <div className="bg-base-100/90 relative w-[100vw] h-[100vh]">
                        <label htmlFor="search-modal" onClick={() => setOpenSearchModal(false)}
                            className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent border-none">✕</label>
                        
                        <div className="w-full h-full flex flex-col justify-center items-center p-4 md:p-12">
                            <div className="row w-full"  onClick={(e) => e.stopPropagation()}>
                                <div className="col-12">
                                    <form onSubmit={handleSubmit} className="w-full flex flex-row justify-between items-center">
                                        <input ref={inputRef} type="text" placeholder="Search for..." name="query" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
                                            className="input p-0 grow bg-transparent focus:outline-0 focus:border-primary
                                            border-x-0 border-t-0 rounded-none border-b border-solid border-[#e0e0e0] w-auto text-2xl font-bold" />
                                        <button type="submit"><BiSearch size="32px" /></button>
                                    </form>
                                </div>
                            </div>
                            <div className="row w-full"  onClick={(e) => e.stopPropagation()}>
                                <div className="col-12">
                                    <h2 className="text-base font-bold mt-4 mb-4">Popular Searches</h2>

                                    <div className="flex-row">
                                        <button className="btn btn-outline mr-3 mb-3 border text-sm" onClick={() => handleQuery("Healing")}>
                                            Healing
                                        </button>
                                        <button className="btn btn-outline mr-3 mb-3 border text-sm" onClick={() => handleQuery("Communion")}>
                                            Communion
                                        </button>
                                        <button className="btn btn-outline mr-3 mb-3 border text-sm" onClick={() => handleQuery("Rest")}>
                                            Rest
                                        </button>
                                        <button className="btn btn-outline mr-3 mb-3 border text-sm" onClick={() => handleQuery("Worship")}>
                                            Worship
                                        </button>
                                        <button className="btn btn-outline mr-3 mb-3 border text-sm" onClick={() => handleQuery("Faith")}>
                                            Faith
                                        </button>
                                        <button className="btn btn-outline mr-3 mb-3 border text-sm" onClick={() => handleQuery("Hope")}>
                                            Hope
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Login Modal */}
                <div className={`modal z-[100000] ` + (openLoginModal ? 'modal-open' : '')} onClick={() => closeLoginModal()}>
                    <div className="modal-box max-w-sm relative bg-neutral rounded" onClick={(e) => e.stopPropagation()}>
                        <button onClick={() => closeLoginModal()} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent border-none">✕</button>
                        <Login loginHasErrors={loginHasErrors} />
                    </div>
                </div>
            </div>

            {/* Mobile Hamburger */}
            <div className="drawer-side">
                <label htmlFor="hamburger-menu" className="drawer-overlay" onClick={() => setIsHamburgerOpen(false)}></label>
                <ul className="menu p-4 overflow-y-auto w-80 bg-neutral text-base-content">
                    <li tabIndex="0"><a href="/monthly-offer">Monthly Offer</a></li>
                    <li tabIndex="0"><a href="/prayer">Prayer</a></li>
                    <li tabIndex="0"><a href="/blog/praise-reports">Praise Reports</a></li>
                    <li tabIndex="0"><a href="/donate">Be a Grace Legacy Builder</a></li>
                    <li tabIndex="0"><a href="/">Back to JosephPrince.org</a></li>
                    <hr className="mt-4 mb-4" />
                    {isLoggedIn ?
                        <>
                            <li><a href="/account">My Account</a></li>
                            <li><a href="/account/library">Library</a></li>
                            <li><a href="/logout">Log Out</a></li>
                        </>
                    : 
                        <>
                            <li><a href="#login">Log In</a></li>
                            <li><a href="/register?source=plus&new=true">Sign Up</a></li>
                        </>
                    }
                </ul>
            </div>
        </div>  
        </>
    );
}
